

export type StrapiRichTextNode = {
  type:
  | 'text'
  | 'heading'
  | 'paragraph'
  | 'list'
  | 'list-item'
  | 'link'
  | 'quote'
  | 'code'
  | 'image';
  level?: 1 | 2 | 3 | 4 | 5 | 6;
  format?: 'unordered' | 'ordered';
  text?: string;
  url?: string;
  bold?: boolean;
  code?: boolean;
  italic?: boolean;
  strikethrough?: boolean;
  underline?: boolean;
  image?: StrapiMedia;
  children?: StrapiRichTextNode[];
};

export type StrapiImage = {
  url: string;
  width: number;
  height: number;
  caption: string | null;
  alternativeText: string | null;
}

export type StrapiImageFormats = "xsmall" | "thumbnail" | "small" | "medium" | "large";

export type StrapiImageProps = {
  media: StrapiMedia;
  loadingType: "lazy" | "eager" | undefined;
  format?: StrapiImageFormats; // Bevorzugtes Format
  className?: string;
  altText?: string;
};


export type StrapiMedia = {
  id: number;
  alternativeText: string | null;
  url: string;
  width?: number;
  height?: number;
  mime: string;
  name: string;
  caption: null | string;
  formats?: {
    xsmall?: StrapiImage,
    thumbnail?: StrapiImage,
    small?: StrapiImage,
    medium?: StrapiImage,
    large?: StrapiImage,
  }
};


export type StrapiVideo = {
  alternativeText: string;
  url: string;
  width?: number;
  height?: number;
  mime: string;
  id: number;
};

export type POIType = {
  id: number;
  title: string;
  content: StrapiRichTextNode[] | null;
  position: { x: number, y: number, z: number };
  target: { x: number, y: number, z: number };
  camera_position: { x: number, y: number, z: number };
}

export type PageSection =
  | ContentSection
  | ImageTextSection
  | FormSection
  | GallerySection;


export interface ContentSection {
  __component: 'elements.content';
  id: number;
  dark: boolean;
  content: StrapiRichTextNode[] | null;
  orientation: "Left" | "Right"
}

export interface ImageTextSection {
  __component: 'elements.image-text-section';
  id: number;
  content: {
    content: StrapiRichTextNode[]
  } | null;
  gallery: {
    id: number;
    image: StrapiMedia[] | null
  } | null;
  Layout: 'Left' | 'Right';
}


export interface SocialAccounts {
  id: number,
  twitter: string,
  linkedin: string,
  instagram: string
  bluesky: string
}



export type GeneralMetadata = {
  title: string;
  name: string;
  description: string;
  keywords: string;
  favicon: StrapiMedia;
  seo: SEO;
  socialAccounts: SocialAccounts | null;
  weglotID: string | null;
};


export interface FormSection {
  __component: 'elements.form-section';
  id: number;
  content: StrapiRichTextNode[] | null;
  formHash: string | null;
  userName: string | null;
}

export interface GallerySection {
  __component: 'elements.gallery';
  id: number;
  image: StrapiMedia[] | null
}

export type IdeenWettbewerbPage = {
  Headercontent: StrapiRichTextNode[] | null;
  Headerimage: StrapiMedia;
  sections: PageSection[];
}


export type DefaultContentPage = {
  title: string;
  content: StrapiRichTextNode[] | null;
}

export type AboutContentPage = {
  title: string;
  sections: PageSection[];
}

export type ControlSettings = {
  min_horizontal: number;
  max_horizontal: number;
  min_vertical: number;
  max_vertical: number;
  min_distance: number;
  max_distance: number;
  useDistance: boolean;
  useHorizontal: boolean;
  useVertical: boolean;
}


export type FloatAnimationSettings = {
  enabled: boolean;
  speed: number;
  rotationIntensity: number;
  floatingRange: {
    min: number;
    max: number;
  }
}


export type PageType = {
  id: number;
  documentId: string;
  title: string;
  isHouse: boolean;
  teaserTitle: string;
  sharetext: string;
  content: StrapiRichTextNode[] | null;
  background: StrapiMedia | null;
  reflection: StrapiMedia | null;
  teaser_image: StrapiMedia | null;
  backToTopImage: StrapiMedia | null;
  video: StrapiVideo[] | null;
  video_poster: StrapiMedia | null;
  model: StrapiMedia;
  slug: string;
  pois: POIType[],
  animation_freeze: number,
  default_camera_position: { x: number, y: number, z: number };
  default_camera_target: { x: number, y: number, z: number };
  seo?: SEO;
  controls?: ControlSettings;
  floatAnimation: null | FloatAnimationSettings;
  qrImage: StrapiMedia | null;
};


import { Camera, Clock, Mesh, Scene, WebGLRenderer } from "three";

export type SEO = {
  meta_description: string;
  meta_keywords: string;
  meta_image: StrapiImage
}


export type AlwaysAnimatedMaterialOptions = {
  clock: Clock
  gl: WebGLRenderer,
  camera: Camera,
  scene: Scene,
  mesh: Mesh,
}

export type AnimatedMaterialOptions = {
  animationTime: number,
  clock: Clock,
  gl: WebGLRenderer,
  camera: Camera,
  scene: Scene,
  mesh: Mesh,
}

export type ImageBackgroundSection = {
  __component: 'elements.image-background-section';
  id: number;
  title: string;
  content: StrapiRichTextNode[] | null;
  image: StrapiMedia | null;
  orientation: "Left" | "Right";
  align: "Top" | "Center"
}

export type KuenstlerSection = {
  __component: 'object.kuenstler';
  id: number;
  Kuenstler: string;
  real_kuenstler?: Kuenstler | null;
}

export type Kuenstler = {
  title: string;
  description: StrapiRichTextNode[];
  single_kuenstler: SingleKuenstler[] | null;
}

export type SingleKuenstler = {
  title: string;
  description: StrapiRichTextNode[];
  image: StrapiMedia;

}

export type HomeType = {
  smartphoneCta: StrapiRichTextNode[];
  smartphoneMedia: StrapiMedia | null;
  qrImage: StrapiMedia | null;
  entryImage: StrapiMedia | null;
  sections: HomeSections
}

export type PlaceholderType = {
  sections: HomeSections
}

export type HomeSections = (ContentSection | FormSection | GallerySection | ImageTextSection | ImageBackgroundSection | KuenstlerSection)[]

export const INTERNAL_LINK = {
  Startseite: "/",
  Teilnahmebedingungen: "/teilnahmebedingungen",
  Impressum: "/impressum",
  Datenschutz: "/datenschutz",
  Ideenwettbewerb: "/ideenwettbewerb",
  EnglishVersion: "/english-version",
  Subpage: "/exhibition",
  About: "/ueber-bua",
  BARN: "/the-barn"
}